import React, { useCallback } from 'react'
import { Form, Select } from 'antd'
import { useModalContext } from '@context/modalContext'
import { useMessage } from '@hooks/useMessage'
import axiosInstance from '../../../config/axios'
import { serverPath } from '@constants/api-endpoints'
import { errorMapper } from '@utils/errorMapper'
import { ErrorMessages } from '@constants/errors'
import styles from './ProfileUpdate.module.scss'
import ButtonUi from '../../ui/ButtonUi/ButtonUi'
import InputWithLabel from '../../ui/InputWithLabel/InputWithLable'
import { EUserRoles } from '@enums/roles'
import { roleNameMapper } from '@utils/mappers'
import WithLabel from '@components/ui/WithLabel/WithLabel'
import CrmSelect from '@components/ui/CrmSelect/CrmSelect'
import { IUsers } from '@interfaces/user.interface'
import { useUserSelector } from '@store/selectors/auth'

const { Option } = Select

interface ICreate {
  login: string
  nickName: string
  password: string
}

interface Props {
  update?: () => void
}

const ProfileUpdateModal: React.FC<Props> = ({ update }) => {
  const user = useUserSelector()
  const { setModalComponent } = useModalContext()
  const { error, success } = useMessage()
  const updateHandler = useCallback(async (e: ICreate) => {
    try {
      await axiosInstance.put(serverPath.USERS_MANAGER + '/' + user.id, { ...e, role: user.role })
      success('Профиль обновлен успешно')
      update && update()
      setModalComponent({ component: null })
    } catch (e) {
      error(errorMapper(ErrorMessages.UPDATE_DATA, e), 'Ошибка обновлении профиля')
    }
  }, [])
  return (
    <div className={styles.container}>
      <Form name='basic' onFinish={updateHandler}>
        <Form.Item
          className={styles.item}
          initialValue={user.login}
          rules={[
            { required: true, message: 'введите логин' },
            { min: 3, message: 'минимальная длинна 3 символа' },
          ]}
          name='login'
        >
          <InputWithLabel placeholder='Логин' label='Логин:' disabled />
        </Form.Item>
        <Form.Item
          className={styles.item}
          initialValue={user.nickName}
          rules={[
            { required: true, message: 'введите ник' },
            { min: 3, message: 'минимальная длинна 3 символа' },
          ]}
          name='nickName'
        >
          <InputWithLabel placeholder='Ник' label='Ник:' />
        </Form.Item>
        <Form.Item
          className={styles.item}
          rules={[
            { max: 10, message: 'длинна не больше 10 символов' },
            { min: 3, message: 'минимальная длинна 3 символа' },
          ]}
          name='password'
        >
          <InputWithLabel placeholder='Пароль' label='Пароль:' />
        </Form.Item>
        <div className={styles.actions}>
          <ButtonUi onClick={() => setModalComponent({ component: null })}>Отмена</ButtonUi>
          <ButtonUi className={styles.submit} type='primary' htmlType='submit' color='green'>
            Обновить
          </ButtonUi>
        </div>
      </Form>
    </div>
  )
}

export default ProfileUpdateModal
